
import { mapState } from 'vuex'
import History from '../-history'
import CtTab from '../components/tab.vue'
import { isHiddenHeaderFn } from '@/utils/utils'

// opCodes for non-trajectory nodes to exclude from display (global: only 654 this phase)
const EXCLUDED_ROUTE_OP_CODES = ['654']
// Indonesia local shipment: additionally exclude opCode 8000 (keep current behavior)
const INDONESIA_LOCAL_EXCLUDED_OP_CODES = ['8000', '654']

export default {
  components: {
    CtTab,
  },
  props: {
    initWaybillParams: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    const requiredCheckRule = (rule, value, callback) => {
      // if( this.$route.query.customer_type ){ return true }
      if (!value) {
        callback(this.$t('serviceSupport.querySupport.waybills.enterWaybills'))
      }
    }

    // 自定义校验函数
    const checkRule = (rule, value, callback) => {
      // if( this.$route.query.customer_type ){ return true }
      if (!value) {
        callback(this.$t('serviceSupport.querySupport.waybills.enterWaybills'))
        return
      }
      // 本地件模式：跳过国际件运单号长度校验，但限制最多20个
      if (this.isLocalQuery) {
        const orderArr = this.getSplitStr(value)
        if (orderArr.length > 20) {
          callback(
            this.$t('serviceSupport.querySupport.waybills.wayBillNumberError')
          )
          return
        }
        callback()
        return
      }
      if (this.checked) {
        return true
      }
      const orderArr = this.getSplitStr(value)
      if (orderArr.length > 20) {
        // 如果需要返回 error msg，就把它传给 `callback()`
        callback(
          this.$t('serviceSupport.querySupport.waybills.wayBillNumberError')
        )
        return
      }
      if (!this.isSgSite) {
        for (let i = 0; i < orderArr.length; i++) {
          if (!(orderArr[i].length === 12 || orderArr[i].length === 15)) {
            callback(
              this.$t('serviceSupport.querySupport.waybills.wayBillLengthError')
            )
            return
          }
        }
      } else {
        for (let i = 0; i < orderArr.length; i++) {
          if (![10, 12, 13, 15].includes(orderArr[i].length)) {
            callback(
              this.$t('serviceSupport.querySupport.waybills.enterRightWaybills')
            )
            return false
          }
        }
      }

      // 如果通过校验，调用无参数的 `callback()` 即可
      callback()
    }
    return {
      queryType: 'international',
      form: this.$form.createForm(this, { name: 'waybill' }),
      ticket: '',
      hisData: [],
      isRemember: false,
      isLoading: false,
      rules: [
        {
          validator: checkRule,
        },
      ],
      requiredRules: [
        {
          validator: requiredCheckRule,
        },
      ],
      checked: false,
      isNoShowCustomerType: false,
      initTimer: null,
      searchTimer: null,
      isPseudoLoginVerified: false,
      pseudoLoginEncryptedPhone: '', // 伪登录加密手机号，传给后端做兜底判断
      isOwnWaybillFlag: false,
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      isAgree: (state) => state.cookie_agree.agree,
      site: (state) => state.site,
      lang: (state) => state.lang,
      loginToken: (state) => state.loginToken,
      loginUser: (state) => state.loginUser,
    }),
    isSgSite() {
      return this.site.toUpperCase() === 'SG'
    },
    isLocalQuery() {
      return this.queryType === 'local'
    },
    customerType() {
      return this.$route.query.customer_type
    },
    isSamsung() {
      return this.customerType === 'samsung'
    },
    // 判断是否已登录
    isLoggedIn() {
      return !!(this.loginToken && this.loginUser)
    },
    pseudoLoginParams() {
      const waybillNo = this.$route.query.waybillNo
      const rawPhone = this.$route.query.encryptedPhone || ''
      return {
        waybillNo,
        encryptedPhone: rawPhone ? encodeURIComponent(rawPhone) : '',
      }
    },
    isPseudoLoginMode() {
      return !!(
        this.pseudoLoginParams.waybillNo &&
        this.pseudoLoginParams.encryptedPhone
      )
    },
    isHiddenHeader() {
      return isHiddenHeaderFn(this.$route, true)
    },
  },
  mounted() {
    if (this.$route.query.customer_type) {
      this.getCustomerTypeConfig()
    } else {
      this.initialization()
    }
  },
  beforeDestroy() {
    if (this.initTimer) {
      clearTimeout(this.initTimer)
    }
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
    }
  },
  methods: {
    // 切换本地/国际件 tab
    handleTabChange(type) {
      this.queryType = type
      this.form.resetFields()
    },
    async getCustomerTypeConfig() {
      try {
        const list = await this.$API.support.getCustomerTypeConfig()
        if (list.includes(this.$route.query.customer_type)) {
          this.isNoShowCustomerType = true
          this.initTimer = setTimeout(() => {
            this.checked = true
            this.initialization()
          }, 1000)
        } else {
          this.isNoShowCustomerType = false
          this.initialization()
        }
      } catch (error) {
        this.initialization()
      }
    },
    initialization() {
      if (this.isPseudoLoginMode) {
        this.handlePseudoLogin()
        return
      }
      // 从 URL 读取 tab 参数，控制标签页选中状态（仅印尼站生效）
      const { tab } = this.$route.query
      if (tab === '2') {
        this.queryType = 'local'
      }
      this.initHistory()

      const { No } = this.$route.query
      // hash这种只是暂时为老官网老地址出的临时解决方案
      // 例如：/sg/en/dynamic_function/waybill/#search/bill-number/SF9600534511679
      const hash = this.$route?.hash
      const No1 = hash.substring(hash?.indexOf('SF'))
      this.$nextTick(() => {
        if (this.initWaybillParams) {
          // 如果是从结果页回来，需要回显之前查询条件
          this.form.setFieldsValue({
            ids: this.initWaybillParams.ids,
          })
          this.isRemember = this.initWaybillParams.isRemember
        } else if (No || No1) {
          this.form.setFieldsValue({
            ids: No || No1,
          })
          this.searchTimer = setTimeout(() => {
            // 移动端进入
            this.handleSearch()
          }, 500)
        }
      })
    },
    getSplitStr(ids) {
      let str = ids.replace(/[\s]+/g, ',')
      str = str.replace(/，/g, ',')
      this.form.setFieldsValue({
        ids: str,
      })
      return str.split(',')
    },
    handleDeleteHisItem(value) {
      this.historyObj.deleteHistoryItem(value)
    },
    // 查询订单
    handleSearch() {
      // 本地件模式：仅允许单个运单号
      if (this.queryType === 'local') {
        const { ids } = this.form.getFieldsValue()
        if (!ids) {
          this.$toast({
            message: this.$t(
              'serviceSupport.querySupport.waybills.enterWaybills'
            ),
            duration: 3000,
          })
          return
        }
        const orderArr = this.getSplitStr(ids)
        if (orderArr.length > 20) {
          this.$toast({
            message: this.$t(
              'serviceSupport.querySupport.waybills.wayBillNumberError'
            ),
            duration: 3000,
          })
          return
        }
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          // 已登录用户: 跳过滑块，直接查询
          if (this.isLoggedIn) {
            this.getData()
            return
          }
          // 未登录用户: 需要滑块验证
          this.$parent.$TencentQRCode
            .verify()
            .then((res) => {
              this.getData(res)
            })
            .catch((error) => {
              console.error('腾讯验证码验证失败:', error)
              this.$toast({
                message:
                  this.$t(
                    'serviceSupport.querySupport.waybills.derificationFailed'
                  ) || 'Verification failed. Please try again.',
                duration: 3000,
              })
            })
        }
      })
    },

    jump2ResultPage() {
      const { site, lang } = this.$route.params
      this.$router.push({
        path:
          '/' +
          site +
          '/' +
          lang +
          '/support/querySupport/waybill/mobile/result',
        query: {
          ...this.$route.query,
          queryType: this.queryType,
        },
      })
    },

    // SISP-OS 本地件查询（本地件 tab 统一走 nativeBills 接口）
    getSispData(opts) {
      const { ids } = this.form.getFieldsValue()
      const orderArr = this.getSplitStr(ids)
      // 本地件 tab 统一调用 getLocalWaybillData（走 nativeBills 接口 + doResultData 处理）
      const waybillNos = orderArr.join(',')
      return this.getLocalWaybillData(waybillNos, opts)
    },
    // SISP-OS opCode 转 opCodeStatus 映射
    mapOpCodeToStatus(opCode) {
      const map = {
        80: 'signed',
        8000: 'signed',
        50: 'collect',
        54: 'pickedup',
        10: 'received',
        20: 'picking',
        30: 'packaged',
        40: 'delivered',
        60: 'delivery',
        70: 'invalid',
      }
      return map[opCode] || 'other'
    },
    // Check if current query is Indonesia site + local shipment tab
    isIndonesiaLocalShipment(route) {
      return this.site === 'id' && this.isLocalQuery
    },
    // Filter out non-trajectory route nodes; Indonesia local shipments keep filtering 8000+654
    filterRouteNodes(list, route) {
      if (!Array.isArray(list)) return list
      const excludeCodes = this.isIndonesiaLocalShipment(route)
        ? INDONESIA_LOCAL_EXCLUDED_OP_CODES
        : EXCLUDED_ROUTE_OP_CODES
      return list.filter(
        (item) => !excludeCodes.includes(String(item.opCode))
      )
    },
    doSispResultData(waybillNo, sispObj) {
      const items = Array.isArray(sispObj) ? sispObj : Object.values(sispObj)
      if (!items || items.length === 0) {
        this.$toast({
          message: this.$t('serviceSupport.querySupport.waybills.noData', [
            waybillNo,
          ]),
          duration: 3000,
        })
        return
      }
      items.sort((a, b) => (b.barScanTs || 0) - (a.barScanTs || 0))
      const barNewList = items.map((item) => {
        const ts = item.barScanTs || 0
        const d = new Date(ts)
        const pad = (n) => String(n).padStart(2, '0')
        const barScanDt = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
          d.getDate()
        )}`
        const barScanTm = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
          d.getSeconds()
        )}`
        return {
          waybillNo: item.wayBillNo || waybillNo,
          opCode: item.opCode,
          opCodeStatus: this.mapOpCodeToStatus(item.opCode),
          opName: item.opName,
          remark: item.remark,
          barScanTm,
          barScanDt,
          barScanTs: item.barScanTs,
          zoneGmt: item.zoneGmt,
          distName: item.distName,
          zoneName: item.outsideName || item.zoneName,
          courierCode: item.courierCode,
          empMobile: item.empMobile,
          note: item.note,
          contnrCode: item.contnrCode,
          vehiclePlate: item.vehiclePlate,
          oprCode: item.oprCode,
        }
      })
      const filteredBarNewList = this.filterRouteNodes(barNewList, null)
      const routeDataArr = [
        { waybillNo, barNewList: filteredBarNewList, isShow: true, isLocal: true },
      ]
      this.$store.commit('support/SET_WAWBILL_RESULT', routeDataArr)
      this.$store.commit('support/SET_WAWBILL_RESULT_BACKUP', routeDataArr)
      this.$emit('track', 'query')
      this.jump2ResultPage()
    },

    // 获取数据
    async getSfData(opts) {
      try {
        const { ids } = this.form.getFieldsValue()

        // 检测本地件（印尼 IDP 等本地运单号），自动走 nativeBills 接口
        const isLocalWaybill = this.detectLocalWaybill(ids)
        if (isLocalWaybill) {
          return this.getLocalWaybillData(ids, opts)
        }

        const urlFn = 'tecentRoutesApi'
        const params = {
          ids,
          app: 'bill',
          isCustomerOrderNo: this.checked,
          // isCustomerOrderNo: true,
          // customer_type: 'test',
          customer_type: this.$route.query.customer_type,
          // 伪登录加密手机号，后端用于兜底运单归属判断
          ...(this.pseudoLoginEncryptedPhone && {
            encryptedPhone: decodeURIComponent(this.pseudoLoginEncryptedPhone),
          }),
          ...opts,
        }
        this.isLoading = true
        // 判断是三星件
        if (this.isSamsung) {
          params.customer_type = this.customerType
        }
        this.setParams(ids)
        const res = await this.$API.common[urlFn](params)
        this.isLoading = false
        if (res.code === 0) {
          this.doResultData(ids, res.result)
        }
      } catch (e) {
        this.ticket = ''
        this.isLoading = false
      }
    },
    // 检测是否为本地运单号（不影响国际件判断）
    detectLocalWaybill(ids) {
      if (!ids) return false
      const waybillList = ids
        .replace(/[\s]+/g, ',')
        .replace(/，/g, ',')
        .split(',')
      // 印尼本地件：SFIDP 开头的运单号
      return waybillList.some((no) => /^SFIDP/i.test(no.trim()))
    },
    // 本地件查询（走 nativeBills 接口）
    async getLocalWaybillData(ids, opts) {
      try {
        const waybillNo = ids.trim()
        this.isLoading = true
        const res = await this.$API.support.sispBarRecordQuery({
          waybillNo,
          ...opts,
        })
        this.isLoading = false
        if (res.code === 0 && res.result) {
          this.doResultData(waybillNo, res.result, true)
        }
      } catch (e) {
        this.isLoading = false
        this.$toast({
          message: this.$t('common.http.networkError'),
          duration: 3000,
        })
      }
    },
    // 保存参数
    setParams(ids) {
      const params = {
        ids,
        isRemember: this.isRemember,
      }
      this.$store.commit('support/SET_WAWBILL_PARAMS', params)
    },
    doResultData(ids, res, isLocal = false) {
      this.ticket = ''
      let routeDataArr = res || []
      this.$emit('track', 'query')
      // 过滤
      // routeDataArr = routeDataArr.filter((item) => {
      //   return item.destCityName && item.sourceCityName
      // }).map((it) => {
      //   if ((!this.isSamsung && it.changeOrderControl !== 0) || !this.isSgSite) {
      //     delete it.directives
      //   }
      //   return it
      // })
      routeDataArr = routeDataArr.map((it) => {
        if (
          (!this.isSamsung && it.changeOrderControl !== 0) ||
          !this.isSgSite
        ) {
          delete it.directives
        }
        if (isLocal) {
          it.isLocal = true
        }
        return it
      })

      if (routeDataArr.length === 1) {
        routeDataArr[0].isShow = true
        // barNewList 为空时不显示路由数据，状态改为"配送准备中"
        if (!routeDataArr[0].barNewList || routeDataArr[0].barNewList.length === 0) {
          routeDataArr[0].barNewList = []
          routeDataArr[0].awaitingPickup = true
          routeDataArr[0].isShow = false
        } else {
          routeDataArr[0].barNewList = routeDataArr[0].barNewList.reverse()
          routeDataArr[0].barNewList = this.filterRouteNodes(routeDataArr[0].barNewList, routeDataArr[0])
        }
        this.jump2ResultPage()
      } else if (routeDataArr.length === 0) {
        this.$toast({
          message: this.$t('serviceSupport.querySupport.waybills.noData', [
            ids,
          ]),
          duration: 3000,
        })
      } else {
        routeDataArr.forEach((item) => {
          item.isShow = false
          if (isLocal) {
            item.isLocal = true
          }
          // barNewList 为空时不显示路由数据，状态改为"配送准备中"
          if (!item.barNewList || item.barNewList.length === 0) {
            item.barNewList = []
            item.awaitingPickup = true
          } else {
            item.barNewList = item.barNewList.reverse() // 倒序
            item.barNewList = this.filterRouteNodes(item.barNewList, item)
          }
        })
        this.jump2ResultPage()
      }
      if (this.isOwnWaybillFlag) {
        routeDataArr = routeDataArr.map((item) => ({ ...item, isOwn: true }))
        this.isOwnWaybillFlag = false
      }
      this.$store.commit('support/SET_WAWBILL_RESULT', routeDataArr)
      this.$store.commit('support/SET_WAWBILL_RESULT_BACKUP', routeDataArr)
    },
    // 获取数据
    async getData(opts) {
      // 本地件模式：走 SISP-OS 查询
      if (this.isLocalQuery) {
        // 保存本地
        this.saveFormData2Cache()
        // 已登录用户：走归属判断，自己的运单免滑块
        if (this.isLoggedIn) {
          const { ids } = this.form.getFieldsValue()
          await this.validateWaybillRel(ids, opts)
          return
        }
        // 未登录用户需要滑块验证
        if (!(opts && opts.ticket)) {
          this.$parent.$TencentQRCode
            .verify()
            .then((cap) => {
              this.getSispData({ ...opts, ...cap })
            })
            .catch((error) => {
              console.error('腾讯验证码验证失败:', error)
              this.$toast({
                message:
                  this.$t(
                    'serviceSupport.querySupport.waybills.derificationFailed'
                  ) || 'Verification failed. Please try again.',
                duration: 3000,
              })
            })
          return
        }
        this.getSispData(opts)
        return
      }
      // 保存本地
      this.saveFormData2Cache()

      // 新增：获取运单号列表
      const { ids } = this.form.getFieldsValue()
      const waybillList = ids

      // 伪登录模式：根据验证结果决定是否免滑块
      if (this.isPseudoLoginVerified) {
        this.getSfData(opts)
        return
      }

      // 已登录用户：调用 getWaybillRel 判断是否自己的运单
      if (this.isLoggedIn) {
        await this.validateWaybillRel(waybillList, opts)
        return
      }

      // 未登录/普通用户：唤起滑块验证码
      // 如果 opts 已包含验证码结果（来自 handleSearch），直接查询
      if (opts && opts.ticket) {
        this.getSfData(opts)
        return
      }
      this.$parent.$TencentQRCode
        .verify()
        .then((cap) => {
          this.getSfData({ ...opts, ...cap })
        })
        .catch((error) => {
          console.error('腾讯验证码验证失败:', error)
          this.$toast({
            message:
              this.$t(
                'serviceSupport.querySupport.waybills.derificationFailed'
              ) || 'Verification failed. Please try again.',
            duration: 3000,
          })
        })
    },
    // 运单归属判断（已登录用户）
    async validateWaybillRel(waybillNo, opts) {
      const queryFn = (o) =>
        this.isLocalQuery ? this.getSispData(o) : this.getSfData(o)
      try {
        this.isLoading = true
        const res = await this.$API.support.getWaybillRel({ waybillNo })
        if (res?.result === true) {
          // 是自己的运单，免滑块直接查询
          queryFn(opts)
        } else {
          // 不是自己的运单，唤起滑块验证
          this.$parent.$TencentQRCode
            .verify()
            .then((cap) => {
              queryFn({ ...opts, ...cap })
            })
            .catch((error) => {
              console.error('腾讯验证码验证失败:', error)
              this.$toast({
                message:
                  this.$t(
                    'serviceSupport.querySupport.waybills.derificationFailed'
                  ) || 'Verification failed. Please try again.',
                duration: 3000,
              })
            })
        }
      } catch (error) {
        console.error('getWaybillRel API failed:', error)
        // API 失败，降级为滑块验证
        this.$parent.$TencentQRCode
          .verify()
          .then((cap) => {
            queryFn({ ...opts, ...cap })
          })
          .catch((err) => {
            console.error('腾讯验证码验证失败:', err)
            this.$toast({
              message:
                this.$t(
                  'serviceSupport.querySupport.waybills.derificationFailed'
                ) || 'Verification failed. Please try again.',
              duration: 3000,
            })
          })
      } finally {
        this.isLoading = false
      }
    },
    async handlePseudoLogin() {
      const { waybillNo, encryptedPhone } = this.pseudoLoginParams
      try {
        this.isLoading = true
        this.form.setFieldsValue({ ids: waybillNo })
        // 前置拦截：调用 checkPhoneWaybillRel 判断运单归属
        const res = await this.$API.support.checkPhoneWaybillRel({
          encryptedPhone: decodeURIComponent(encryptedPhone),
          waybillNo,
        })
        this.isPseudoLoginVerified = res?.result === true
        // 保存 encryptedPhone，查询时传给后端做兜底判断
        this.pseudoLoginEncryptedPhone = encryptedPhone
      } catch (error) {
        console.error('伪登录验证失败:', error)
        this.isPseudoLoginVerified = false
      } finally {
        this.isLoading = false
        // 验证完成后自动触发查询
        this.getData()
      }
    },
    saveFormData2Cache() {
      if (this.isRemember) {
        const { ids } = this.form.getFieldsValue()
        this.historyObj.setCache(ids)
      }
    },
    initHistory() {
      this.historyObj = new History({
        site: this.site,
        maxVisibleNum: 3,
        viewContext: this,
      })
      this.initHisData()
    },
    // 初始化历史查询
    initHisData() {
      this.isAgree ? (this.isRemember = true) : (this.isRemember = false)
      this.hisData = this.historyObj.getShowDateObj()
    },
    handleChangeNumber(value) {
      this.form.setFieldsValue({
        ids: value,
      })
    },
    formatwaybill(str) {
      return str.replace(/[{a-z":]*(([a-zA-z]{2,5}\d+)(,$2)*)(["}]+)?/, '$1')
    },
    changeChecked() {
      this.form.setFieldsValue({
        ids: this.form.getFieldsValue().ids,
      })
    },
    // 点击查询说明  进入查询说明页面
    queryDescription() {
      //  this.$router.push({
      //   path: '/consulting/queryDescription',
      // })
      // this.$router.replace({
      //   name: 'consulting-queryDescription'
      // })
      this.$router.push({
        name: 'site-lang-consulting-queryDescription',
        params: {
          site: this.site,
          lang: this.lang,
        },
      })
    },
  },
}
